module.exports = __webpack_public_path__ + "img/user.91b18412.svg";